import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/** Checkbox ids have to survive role names like "Board Member". */
const slug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
/**
 * Roles as a labelled checklist rather than a multi-select, so the person choosing can read what
 * each one actually lets somebody do. The people using this screen are not the people who wrote
 * the permission names.
 */
const RolePicker = (props) => {
    const toggle = (name) => props.onChange(props.value.includes(name)
        ? props.value.filter(r => r !== name)
        : [...props.value, name]);
    if (props.roles.length === 0) {
        return (_jsx("p", { className: "text-muted mb-0", children: "This community has no roles yet. Create one under Roles and permissions first." }));
    }
    return _jsx(_Fragment, { children: props.roles.map(role => (_jsxs("div", { className: "form-check mb-3", children: [_jsx("input", { className: "form-check-input", type: "checkbox", id: `role-${slug(role.name)}`, checked: props.value.includes(role.name), onChange: () => toggle(role.name) }), _jsxs("label", { className: "form-check-label", htmlFor: `role-${slug(role.name)}`, children: [_jsx("span", { className: "fw-semibold", children: role.name }), role.description && _jsx("span", { className: "d-block text-muted small", children: role.description })] })] }, role.name))) });
};
export default RolePicker;
